import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { SiteService } from '../../services';
import { editedSiteAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_SITE),
    switchMap(action =>
      SiteService.edit(action.site, store).pipe(
        map(data => editedSiteAction(data)),
        catchError(retryAuthentication(action$, 'epics/sites/editSite'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/editSite.js